/**
 * Haelt automatische Key Results aktuell (V-06, F-22): sobald eine
 * Gewohnheit abgehakt, eine Note oder ein Training eingetragen wird, zieht der Ist-Wert
 * nach - mit Eintrag im Verlauf, wie eine Eingabe von Hand. Einmal in der
 * Huelle, zeigt nichts an.
 */
import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { updateKeyResultValue } from '@/db/repositories/goals';
import { abgleich, type AutoUpdate } from '@/domain/goals/automatisch';
import { kennTage } from '@/db/repositories/ernaehrungUeberblick';
import { addDays, today } from '@/lib/datetime';

export function KeyResultAbgleich() {
  const updates = useLiveQuery(async (): Promise<AutoUpdate[]> => {
    const goals = (await db.goals.toArray()).filter((g) => g.keyResults.some((k) => k.quelle));
    if (goals.length === 0) return [];
    const habitIds = [...new Set(goals.flatMap((g) => g.keyResults.flatMap((k) => (k.quelle?.art === 'gewohnheit' ? [k.quelle.habitId] : []))))];
    const training = goals.some((g) => g.keyResults.some((k) => k.quelle?.art === 'training'));
    // Ernaehrung (F-35 E): ab dem fruehesten Zielbeginn bzw. Wochenanfang.
    const ernVon = goals.filter((g) => g.keyResults.some((k) => k.quelle?.art === 'ernaehrung')).map((g) => g.periodStart).sort()[0];
    const heute = today();
    const [habitEntries, grades, settings, protokolle, uebungen] = await Promise.all([
      habitIds.length ? db.habitEntries.where('habitId').anyOf(habitIds).toArray() : [],
      db.grades.toArray(),
      db.schoolSettings.get('schule'),
      training ? db.trainingsprotokolle.toArray() : [],
      training ? db.uebungen.toArray() : [],
    ]);
    const von = ernVon ? (addDays(heute, -7) < ernVon ? addDays(heute, -7) : ernVon) : null;
    const ernaehrung = von && von <= heute ? await kennTage(von, heute) : [];
    return abgleich(goals, {
      habitEntries, grades, notensystem: settings?.notensystem ?? 'punkte',
      protokolle, bibliothek: new Map(uebungen.map((u) => [u.id, u])), ernaehrung,
    }, heute);
  }, [], [] as AutoUpdate[]);

  useEffect(() => {
    for (const u of updates) void updateKeyResultValue(u.goalId, u.krId, u.wert);
  }, [updates]);

  return null;
}
